import { inject } from "@angular/core";
import { CanMatchFn, RedirectCommand, Router } from "@angular/router";
import { map } from "rxjs";
import {
  AuthenticationService,
  AuthenticationState,
} from "../authentication.service";

export const authGuard: CanMatchFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.currentUserForAuthGuards.pipe(
    map((authenticationResult) => {
      if (authenticationResult.state === AuthenticationState.Authenticated) {
        return true;
      }

      const fullUrl = window.location.pathname + window.location.search;

      return new RedirectCommand(
        router.parseUrl(`/login?returnUrl=${encodeURIComponent(fullUrl)}`)
      );
    })
  );
};
